module.exports = __webpack_public_path__ + "img/mg@3x.b18e46c3.png";